export default __webpack_public_path__ + "static/media/image.jetapp-international.20838fd1.png";